const STORAGE_URL = import.meta.env.VITE_PUBLIC_STORAGE_URL;

export const getImagePath = (
  imagePath: string | undefined,
  placeholder = ""
) => {
  if (imagePath && imagePath.length > 0) return STORAGE_URL + imagePath;
  return placeholder;
};

/*
  Identity colours are data encoding, not chrome — see docs/adr/0003. Six tokenised
  hues; the returned class pair is `bg-*` plus the matching foreground, so callers
  never pick one themselves.

  The foreground is a single token rather than six, because every identity hue in a
  theme sits at roughly one lightness: they are light on the dark themes and dark on
  Paper, so `on-identity` inverts with the theme and one value covers all six. Call
  sites used to hard-code `text-white`, which was already unreadable on identity-3
  (a pale lime) before any of this was themeable.
*/
const IDENTITY_CLASSES = [
  "bg-identity-1 text-on-identity",
  "bg-identity-2 text-on-identity",
  "bg-identity-3 text-on-identity",
  "bg-identity-4 text-on-identity",
  "bg-identity-5 text-on-identity",
  "bg-identity-6 text-on-identity",
] as const;

/*
  Hash the whole id, not just its first character. The previous implementation
  (`id.charCodeAt(0) % 3`) collapsed every account onto three buckets and made
  anonymous Loop pseudonyms collide constantly.
*/
export const getIdentityColor = (id?: string): string => {
  if (!id || id.length === 0) return IDENTITY_CLASSES[0];
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = (hash * 31 + id.charCodeAt(i)) | 0;
  }
  return IDENTITY_CLASSES[Math.abs(hash) % IDENTITY_CLASSES.length];
};
